//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import {
  NavGroup,
  StateFactory,
  componentNameToTemplate,
  hasAllFeatures,
  lazyLoadModule,
} from 'app/initialization/routing/stateHelpers';

export const states = {
  agentsDashboard: StateFactory({
    url: '/agents',
    template: componentNameToTemplate('agentsDashboardPage'),
    data: {
      title: 'Agents',
      navGroup: NavGroup.AGENTS,
      hasAccess: () => hasAllFeatures(FeatureNames.AgentsDashboard),
    },
    resolve: {
      ...lazyLoadModule(
        'curalate.agentsDashboard',
        () => import('@agents-dashboard/agentsDashboardApp'),
      ),
    },
  }),
};
